import { Box, Typography } from "@mui/material";
import React from "react";
import { useDropzone } from "react-dropzone";
import upload from "../Assets/Images/UploadGalleryImage.svg";
import { toast } from "react-toastify";

export default function DragandDrop({
  setImage,
  setFormikImage,
  currentImages = [], 
}) {
  const { getRootProps, getInputProps } = useDropzone({
    accept: {
      "image/*": [],
    },
    multiple: false, // Changed from true to false
    onDrop: (acceptedFiles) => {
      let merged = [];
      if (acceptedFiles.length > 0) {
        const file = acceptedFiles[0];
        if (file.size <= 2 * 1024 * 1024) {
          merged = [file];
        } else {
          toast.error("Selected file exceeds 2 MB limit.");
        }
      }
      setImage(merged);
      setFormikImage && setFormikImage();
    },
  });

  return (
    <div>
      <Box
        sx={{
          background: `#EFEDED`,
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          justifyContent: "center",
          width: "100%",
          mb: 2,
          cursor: "pointer",
        }}
        {...getRootProps()}
        borderRadius="20px"
        border={"none"}
        p={2}
        m={"auto"}
        height={"220px"}
        width={"100%"}
        // maxWidth={"450px"}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            justifyContent: "center",
            width: "100%",
            height: "100%",
            position: "relative",
          }}
        >
          <input {...getInputProps()} />
          {/* Preview selected images inside drop area */}
          {currentImages && currentImages.length > 0 && (
            <Box
              sx={{
                display: "flex",
                gap: 1,
                mb: 1,
                width: "100%",
                justifyContent: "center",
                flexWrap: "wrap",
              }}
            >
              {currentImages.map((file, idx) => (
                <img
                  key={idx}
                  src={URL.createObjectURL(file)}
                  alt={`preview-${idx}`}
                  style={{
                    width: 120,
                    height: 120,
                    objectFit: "cover",
                    borderRadius: "10px",
                    border: "1px solid #ccc",
                  }}
                  draggable="false"
                />
              ))}
            </Box>
          )}
          {/* Only show the upload icon and instructions */}
          {currentImages && currentImages.length ===  0 && (
            <figure
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <img
                src={upload}
                alt="logo.."
                width="100px"
                height="100px"
                draggable="false"
                style={{
                  objectFit: "contain",
                  borderRadius: "10px",
                }}
              />
              
            </figure>
          )}
        </div>
      </Box>
    </div>
  );
}
